module.exports = __webpack_public_path__ + "static/Truck23-59106d8d553b1f4c1f695d175c0fddec.png";